import React from "react";
import "./Case.css";

const Case = () => {
  return (
    <div className="case">
      <div className="case__container">
        <div className="case__left">
          <img
            src="https://www.zazmic.com/wp-content/themes/zazmic/img/banner-shapes-webp.webp"
            alt="ai"
            style={{ width: "400px", height: "350px" }}
            className="case__img"
          />
        </div>
        <div className="case__right">
          <h1 className="case__title">Use Cases</h1>
          <p className="case__text">
            Here are some of the benefits of using{" "}
            <span className="case__text-ai">Google Gen AI</span> for Knowledge
            Extraction
          </p>
          <div className="case__list">
            <div className="case__list-block">
              <div className="case__list-dot" />
              <p className="case__list-item">
                <b>Improved accuracy: </b> Gen AI can extract knowledge from
                unstructured text with a high degree of accuracy. This is
                because Gen AI can understand the context of the text and
                identify patterns that would be difficult for traditional
                rule-based systems to identify.
              </p>
            </div>

            <div className="case__list-block">
              <div className="case__list-dot" />
              <p className="case__list-item">
                <b>Reduced manual effort: </b>Gen AI can automate the process of
                extracting knowledge from unstructured text, which can save
                businesses a significant amount of time and money.
              </p>
            </div>
            <div className="case__list-block">
              <div className="case__list-dot" />
              <p className="case__list-item">
                <b>Improved insights:</b> Gen AI can help businesses to gain new
                insights from their data by extracting knowledge from
                unstructured text that would be difficult to identify using
                traditional methods.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Case;
